<template>
  <div class="contact">
    <BaseHero>
      <div class="hero-body">
        <h1 class="title">CONTACT</h1>
        <h2 class="subtitle">
          Need to get in contact with us? Usually social media is the best way.
          <br />
          For business inquiries and everthing else, fill out the form below.
        </h2>
      </div>
    </BaseHero>
    <section class="container contact-body">
      <div class="columns">
        <div class="column is-6 is-offset-3">
          <div data-aos="fade-up" data-aos-delay="350" class="gi-card">
            <form
              name="contact"
              action="https://submit-form.com/URWZ8iWr"
              target="_self"
            >
              <input type="hidden" name="form-name" value="giupdates-contact" />
              <div class="field">
                <label class="label">Full Name</label>
                <div class="control">
                  <input
                    class="input is-medium"
                    type="text"
                    name="Full Name"
                    required
                  />
                </div>
              </div>

              <br />
              <div class="field">
                <label class="label">Company</label>
                <div class="control">
                  <input
                    class="input is-medium"
                    type="text"
                    name="Company Name"
                    required
                  />
                </div>
              </div>

              <br />

              <div class="field">
                <label class="label">Email Address</label>
                <div class="control">
                  <input
                    class="input is-medium"
                    type="email"
                    name="Email Address"
                    required
                  />
                </div>
              </div>

              <br />

              <div class="field">
                <label class="label">Message</label>
                <div class="control">
                  <textarea class="textarea" required name="Message"></textarea>
                </div>
              </div>
              <br />
              <div class="field is-grouped is-grouped-centered">
                <div class="control">
                  <button type="submit" class="button is-secondary is-medium">
                    Submit
                  </button>
                </div>
              </div>
            </form>
            <br />
            <transition name="list">
              <b-message
                v-show="show"
                type="is-success"
                style="margin-top: 1rem"
              >
                Your message has been sent successfully. We usually try to get
                back to you within a few business days.
              </b-message>
            </transition>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import BaseHero from "@/components/BaseHero";
export default {
  name: "Contact",
  components: { BaseHero },
  data() {
    return {
      show: false,
    };
  },
  methods: {
    toggleShow() {
      this.show = !this.show;
    },
  },
};
</script>

<style lang="scss" scoped>
@media only screen and (max-width: 43.75em) {
  .contact-body {
    padding-left: 1rem;
    padding-right: 1rem;
  }
}
.contact {
  min-height: 100vh;
}
.contact-body {
  margin-top: 5rem;
}
.gi-card {
  background: #0d0c10;
  border: 2px solid darken($color: #bf9c5a, $amount: 20);
  border-top-left-radius: 20px;
  border-bottom-right-radius: 20px;
  padding: 1.5rem;
  text-align: left;
  // box-shadow: #9e8425 0px 1px 2px;
  h1,
  h2,
  a {
    color: #d6b439;
  }
  img {
    max-width: 250px;
    margin-bottom: 2rem;
  }
  p {
    font-size: 1.2rem;
    letter-spacing: 0.02rem;
    font-weight: 300;
  }
}

.label {
  color: #acacac;
}

.red {
  color: red;
  margin-bottom: 1rem;
}

.list-enter,
.list-leave-to {
  visibility: hidden;
  height: 0;
  margin: 0;
  padding: 0;
  opacity: 0;
}

.list-enter-active,
.list-leave-active {
  transition: all 0.3s;
}
</style>
